<template>
  <div class="view-portal-home">
    <div class="container-fluid pt-5">
      <h5 class="page-title mb-1">{{ title }}</h5>
      <p v-if="description" class="portal-description mb-4">
        {{ description }}
      </p>

      <div v-if="!contents.length" class="empty text-center py-5">
        Nenhum conteúdo disponível no momento.
      </div>

      <div v-else class="row">
        <div
          v-for="content in unlockedContents"
          :key="`unlocked-${content.product_id}`"
          class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4"
        >
          <portal-content-card :content="content" />
        </div>

        <div
          v-for="content in lockedContents"
          :key="`locked-${content.product_id}`"
          class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4"
        >
          <portal-locked-card :content="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import get from "lodash/get";
import PortalContentCard from "@/components/portal/PortalContentCard";
import PortalLockedCard from "@/components/portal/PortalLockedCard";

export default {
  name: "PortalHome",
  components: { PortalContentCard, PortalLockedCard },
  computed: {
    ...mapState(["setup"]),
    ...mapState("portal", ["contents"]),
    ...mapGetters("portal", ["unlockedContents", "lockedContents"]),
    title() {
      return get(this.setup, "name") || "Meus conteúdos";
    },
    description() {
      return get(this.setup, "description") || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.view-portal-home {
  .page-title {
    font-size: 20px;
    font-weight: 600;
  }

  .portal-description {
    opacity: 0.7;
    font-size: 14px;
  }

  .empty {
    opacity: 0.7;
  }
}
</style>
